import { Button, Modal } from '@automata/ui';
import { TextareaAutosize } from '@mui/material';
import { Stack } from '@mui/system';
import { useEffect, useState } from 'react';

import { setWorkflowIsSaved } from '../../../features/ui/uiSlice';
import { selectWorkcellInstruments } from '../../../features/workflow/selectors';
import { setWorkflowInstruments } from '../../../features/workflow/workflowSlice';
import { useAppDispatch, useAppSelector } from '../../../hooks';

type Props = {
  onClose: () => void;
};
export const EditWorkcellConfigModal = ({ onClose }: Props) => {
  const dispatch = useAppDispatch();
  const workcellConfig = useAppSelector(selectWorkcellInstruments);
  const [value, setValue] = useState(JSON.stringify(workcellConfig, null, 2));

  useEffect(() => {
    setValue(JSON.stringify(workcellConfig, null, 2));
  }, [workcellConfig]);

  return (
    <Modal open onClose={onClose} title="Edit workcell instruments">
      <Stack gap={3}>
        <TextareaAutosize
          value={value}
          onChange={(e) => setValue(e.target.value)}
          maxRows={20}
        />
        <Stack gap={1}>
          <Button
            variant="outlined"
            onClick={() => {
              dispatch(setWorkflowInstruments(JSON.parse(value)));
              dispatch(setWorkflowIsSaved(false));
            }}
            type="button"
            sx={{ flexGrow: 1 }}
            disabled={value === JSON.stringify(workcellConfig, null, 2)}
          >
            Update
          </Button>
          <Button
            variant="outlined"
            onClick={onClose}
            type="button"
            sx={{ flexGrow: 1 }}
          >
            Close
          </Button>
        </Stack>
      </Stack>
    </Modal>
  );
};
